import { initFederation } from '@angular-architects/native-federation';

initFederation()
  .catch(() => {})
  .then(_ => import('./bootstrap'))
  .catch(() => {});
